import { render, staticRenderFns } from "./LayoutV2.vue?vue&type=template&id=33a6d906&"
import script from "./LayoutV2.vue?vue&type=script&lang=js&"
export * from "./LayoutV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports